module.exports = __webpack_public_path__ + "static/media/pet.d4912b45.png";